import { render, staticRenderFns } from "./UsuariosAdminForm.vue?vue&type=template&id=1ecfa40a&scoped=true"
import script from "./UsuariosAdminForm.vue?vue&type=script&lang=js"
export * from "./UsuariosAdminForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecfa40a",
  null
  
)

export default component.exports